const getters = {
  mdmPatientId(state) {
    return state.data.id;
  },
  getMdmState(state) {
    return state;
  }
};

export default getters;
